import { useSyncExternalStore } from 'react';
/**
 * Checks if the previous state is different from the current state.
 * @template T - The type of the state object.
 * @param previousState - The previous state.
 * @param currentState - The current state.
 * @returns Returns true if the states are different, otherwise false.
 */
function defaultDidChange(previousState, currentState) {
    return previousState !== currentState;
}
export default class Store {
    eventTarget = new EventTarget();
    state;
    constructor(initialState) {
        this.state = initialState;
    }
    set(state) {
        this.state = state;
        this.emitChange();
    }
    patch(patch) {
        this.state = { ...this.state, ...patch };
        this.emitChange();
    }
    emitChange() {
        setTimeout(() => {
            this.eventTarget.dispatchEvent(new Event('change'));
        }, 10);
    }
    subscribe(onChange) {
        this.eventTarget.addEventListener('change', onChange);
        return () => this.eventTarget.removeEventListener('change', onChange);
    }
    get() {
        return this.state;
    }
    use(selector, didChange = (defaultDidChange)) {
        return useSyncExternalStore((onChange) => {
            if (!selector)
                return this.subscribe(onChange);
            let previousState = this.get();
            return this.subscribe(() => {
                const currentState = this.get();
                if (!didChange(previousState, currentState))
                    return;
                previousState = currentState;
                onChange();
            });
        }, () => {
            const state = this.get();
            return selector ? selector(state) : state;
        });
    }
}
